module.exports = __webpack_public_path__ + "img/logo14.ff6f1cf8.png";